import * as _ from 'lodash-es';
import {
  formatDistance,
  differenceInHours,
  format as formatDate,
  isValid as isValidDate,
} from 'date-fns';
import { getUTCDate } from 'lib/Utilities';

export interface ArticleModel {
  publicationDate: string;
  thumbImage: string;
  authorName: string;
  title: string;
  categoryName: string;
  large?: boolean;
  featured?: boolean;
  parentPageSlug: string;
  slug: string;
}

function formatPublicationDate(date: number): string {
  const today = getUTCDate();
  const utcDate = getUTCDate(date);
  let formattedDate;

  if (differenceInHours(today, utcDate) < 24) {
    formattedDate = `${formatDistance(utcDate, today)} ago`;
    formattedDate = formattedDate.replace('about ', '');
  } else {
    formattedDate = formatDate(utcDate, 'LLLL d, yyyy');
  }

  return formattedDate;
}

function formattedPublicationDate(date: string): string {
  const publicationDate = new Date(date);
  const formattedDate = isValidDate(publicationDate)
    ? formatPublicationDate(publicationDate.getTime())
    : '';
  return formattedDate;
}

const ArticleSummariesPresenter = {
  viewModelFrom(articlesData: Record<string, any>[]): ArticleModel[] {
    return articlesData.map((articleData) => ({
      publicationDate: formattedPublicationDate(
        articleData.publication_date || articleData.publicationDate
      ),
      thumbImage: articleData.thumb_image || _.get(articleData.coverSlide, 'photoUrl'),
      authorName: articleData.author.name,
      title: articleData.title,
      slug: articleData.slug,
      categoryName: articleData.category.name,
      parentPageSlug: _.get(articleData.parent_page, 'slug') || 'gallery',
    }));
  },
};

export default ArticleSummariesPresenter;
